import { render, staticRenderFns } from "./UIMutualRecommendationWidget.vue?vue&type=template&id=ad83ea8c"
import script from "./UIMutualRecommendationWidget.vue?vue&type=script&lang=js"
export * from "./UIMutualRecommendationWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
